import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PromoAdjustmentPage } from '@/features/promotion/pages/PromoAdjustmentPage';
import { promoAdjustmentSearchSchema } from '@/features/promotion/types/promotion.types';

export const Route = createFileRoute('/_auth/promotion/adjustment/')({
  validateSearch: promoAdjustmentSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Promotional Item Adjustment">
      <Suspense fallback={<PageLoader />}>
        <PromoAdjustmentPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
